var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.70801C16.3452 8.70801 16.625 8.98783 16.625 9.33301L16.625 21.1575L20.5581 17.2244C20.8021 16.9803 21.1979 16.9803 21.4419 17.2244C21.686 17.4685 21.686 17.8642 21.4419 18.1083L16.4419 23.1083C16.3247 23.2255 16.1658 23.2913 16 23.2913C15.8342 23.2913 15.6753 23.2255 15.5581 23.1083L10.5581 18.1083C10.314 17.8642 10.314 17.4685 10.5581 17.2244C10.8021 16.9803 11.1979 16.9803 11.4419 17.2244L15.375 21.1575L15.375 9.33301C15.375 8.98783 15.6548 8.70801 16 8.70801Z",
    fill: "#9B7CC8",
    stroke: "#9B7CC8",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E8E1F6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTokenIcon);
export default __webpack_public_path__ + "static/media/select-token-icon.e09557ba590fe1b003a77d4eba20475c.svg";
export { ForwardRef as ReactComponent };